import RootComponent from './containers/container';

export default RootComponent;
